import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import * as wjgGrid from '@grapecity/wijmo.grid';
import * as wjCore from '@grapecity/wijmo';
import {MultiRow, MultiRowCellGroup, MultiRowCell} from '@grapecity/wijmo.react.grid.multirow';
import {FlexGridFilter} from '@grapecity/wijmo.react.grid.filter';
import {CollectionView} from '@grapecity/wijmo';
import {Selector} from '@grapecity/wijmo.grid.selector';
import {DataChangeAction} from '@grapecity/wijmo.grid.immutable';
import {ImmutabilityProvider} from '@grapecity/wijmo.react.grid.immutable';

import {gridOperations} from '../../reducks/grid';
import AddIconButton from '../atoms/Buttons/AddIconButton.js';
import DeleteIconButton from '../atoms/Buttons/DeleteIconButton.js';
import PositiveButton from '../atoms/Buttons/PositiveButton.js';
import {isSmartPhone} from '../../common/common.js';

/* usage
  // gridのメソッドを操作するためにrefを作成
  constructor() {
    this.gridRef = React.createRef();
  }

  // render にCustomMultiRowを実装
  let props = {
      headersVisibility: "Column", // 行ヘッダ、列ヘッダの表示設定
                                   // "All" : 列ヘッダセルと行ヘッダセルの両方表示
                                   // "Column" : 列ヘッダセルのみ表示
                                   // "None" : 表示なし
                                   // "Row" : 行ヘッダセルのみ表示
      frozenRows: 1, // 行固定(デフォルト0で固定なし)
      frozenColumns: 1, // 列固定(デフォルト0で固定なし)
      initItems: {key1: value1, ...} // 項目と初期値を設定。
                                     // 行追加したときにinitItemsに設定した項目と初期値をグリッドに追加する。
                                     // 設定しないときはpropsに書かない。
      style: {maxHeight: "600px"}, // グリッドのスタイル設定
      rowHeaderType: "check", // 行ヘッダのスタイルを設定。
                              // "none" : なし
                              // "check" : チェックボックス有効
                              // "radio" : ラジオボタン有効。MultiRowはラジオボタンを使用しないこと。
                              // "edit" : 編集ダイアログ有効
      filterOn: true, // 列フィルター有効無効設定
      filters: ['id', 'xxx'], // filterOn=trueのとき、フィルターを有効にする列を設定
      counterOn: false, // グリッドに設定したデータ件数表示有無を設定
      AddDeleteOn: true, // 行追加削除表示設定
      ArrowButtonOn: true, // 行移動ボタンの表示設定。true:ボタン表示, false:ボタン非表示
      isReadOnly: true, // true:グリッド編集不可, false:グリッド編集可。未指定の場合はfalse
      useStore: true, // true:ストア使用。false:ストアを使用しない。デフォルト。
      editPopupItems: function // 編集ダイアログ処理
      refreshedFunction: function // グリッド更新時の処理
      formatItemFunction: function // セルを表す要素が作成されたときに発生する処理
      checkedFunction: function // チェックボックスがクリックされたときに発生する処理
      doShowMessage: function // this.props.doShowMessageを渡す
      filterChanging: function, // 列フィルターを編集する処理
      customDataMapBinds: string[], // カスタムDataMapを使用しているbinding項目名
      onCellEditEnding: function, // セル編集終了時のカスタム処理

      //ストアを使わない場合、以下のプロパティを設定してください。
      data: [], //一覧に表示するデータ。
    }
    <CustomMultiRow ref={this.gridRef} {...props}>
      // 子コンポーネントを記載
    </CustomMultiRow>

    // 初期値を設定する
  // タイミングは初期処理以外でも可
  // ストアを使わない場合はsetInitItemsを使用しない。
  componentDidMount() {
    this.gridRef.current.setInitItems('1003', [{初期データ}, ...]);
  }

  // MultiRowは行も列もドラッグできない
    参考: https://www.grapecity.co.jp/developer/wijmo
*/

const styles = (theme) => ({
});

const RADIO_UNIQUE_KEY = 'Id';

class CustomMultiRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenId: null,
    };
    this.selector = null;
    this.grid = null;
    this.selectedItems = [];
    this.itemCount = 0;
    this.radioCheckId = null;
    this.filter = null;
    this.isRestore = false;
    this.frozenRows = 0;
    this.frozenColumns = 0;

    this.onGridDataChanged = this.onGridDataChanged.bind(this);
    this.filterChanging = this.props.filterChanging;
    this.customDataMapBinds = this.props.customDataMapBinds;
    this.onCellEditEnding = this.props.onCellEditEnding;

    this.useStore = Object.hasOwnProperty.call(this.props, 'useStore') ?
      this.props.useStore : false;
  }

  render() {
    this.frozenRows = isSmartPhone() ? 0 :
      this.props.frozenRows ? this.props.frozenRows : 0;
    this.frozenColumns = isSmartPhone() ? 0 :
      this.props.frozenColumns ? this.props.frozenColumns : 0;
    if (!this.useStore) {
      return this.renderNoStore();
    } else {
      return this.renderStore();
    }
  }

  renderNoStore() {
    const {counterOn} = this.props;
    const _sourceCollection = this.getSourceCollection();
    let itemCount = 0;
    if (_sourceCollection) {
      itemCount = _sourceCollection.length;
    }
    return (
      <React.Fragment>
        {counterOn &&
          <Typography variant="caption" display="block">
            {itemCount} 件
          </Typography>
        }
        {/* multirowは行列のD&Dができないのでボタンで行移動する */}
        {this.props.ArrowButtonOn &&
        <div>
          <PositiveButton
            id="idMultiRowUp"
            onClick={() => this.doMove(1)}
            variant="contained"
            size="small"
            style={{minWidth: 20}}
            disabled={!!this.props.isReadOnly}>
            <ArrowUpwardIcon />
          </PositiveButton>
          <PositiveButton
            id="idMultiRowDown"
            onClick={() => this.doMove(-1)}
            variant="contained"
            size="small"
            style={{minWidth: 20}}
            disabled={!!this.props.isReadOnly}>
            <ArrowDownwardIcon />
          </PositiveButton>
        </div>}
        <MultiRow
          autoGenerateColumns={false}
          imeEnabled={true}
          initialized={this.initialized.bind(this)}
          deferResizing={false}
          showMarquee={true}
          alternatingRowStep={1}
          headersVisibility={this.props.headersVisibility ? this.props.headersVisibility : 'All'}
          // allowMerging="ColumnHeaders"
          allowSorting="None" // 並び順に意味があるのでソートは無効にする
          selectionMode="MultiRange"
          style={this.props.style ? this.props.style : {height: 'auto'}}
          frozenRows={this.frozenRows}
          frozenColumns={this.frozenColumns}
          isReadOnly={!!this.props.isReadOnly}
          collapsedHeaders={null}
          validateEdits={
            typeof this.props.validateEdits !== 'undefined' ? this.props.validateEdits : true}
        >
          {this.props.AddDeleteOn &&
            <MultiRowCellGroup header=" " align="center">
              <MultiRowCell binding='edit' header=' ' width={60}/>
            </MultiRowCellGroup>
          }
          {this.props.children}
          {this.props.filterOn &&
            <FlexGridFilter initialized={this.initializedFilter.bind(this)}/>}
        </MultiRow>
        <DeleteIconButton isDisabled={!!this.props.isReadOnly}/>
        <AddIconButton isDisabled={!!this.props.isReadOnly}/>
      </React.Fragment>
    );
  }

  renderStore() {
    const {counterOn, items} = this.props;
    return (
      <React.Fragment>
        {counterOn &&
          <Typography variant="caption" display="block">
            {items ? items.length : 0} 件
          </Typography>
        }
        {/* multirowは行列のD&Dができないのでボタンで行移動する */}
        {this.props.ArrowButtonOn &&
        <div>
          <PositiveButton
            id="idMultiRowUp"
            onClick={() => this.doMove(1)}
            variant="contained"
            size="small"
            style={{minWidth: 20}}
            disabled={!!this.props.isReadOnly}>
            <ArrowUpwardIcon />
          </PositiveButton>
          <PositiveButton
            id="idMultiRowDown"
            onClick={() => this.doMove(-1)}
            variant="contained"
            size="small"
            style={{minWidth: 20}}
            disabled={!!this.props.isReadOnly}>
            <ArrowDownwardIcon />
          </PositiveButton>
        </div>}
        <MultiRow
          autoGenerateColumns={false}
          imeEnabled={true}
          initialized={this.initialized.bind(this)}
          deferResizing={false}
          showMarquee={true}
          alternatingRowStep={1}
          headersVisibility={this.props.headersVisibility ? this.props.headersVisibility : 'All'}
          // allowMerging="ColumnHeaders"
          allowSorting="None" // 並び順に意味があるのでソートは無効にする
          selectionMode="MultiRange"
          style={this.props.style ? this.props.style : {height: 'auto'}}
          frozenRows={this.frozenRows}
          frozenColumns={this.frozenColumns}
          isReadOnly={!!this.props.isReadOnly}
          collapsedHeaders={null}
          validateEdits={
            typeof this.props.validateEdits !== 'undefined' ? this.props.validateEdits : true}
        >
          <ImmutabilityProvider
            itemsSource={items}
            dataChanged={this.onGridDataChanged}/>
          {this.props.AddDeleteOn &&
            <MultiRowCellGroup header=" " align="center">
              <MultiRowCell binding='edit' header=' ' width={60}/>
            </MultiRowCellGroup>
          }
          {this.props.children}
          {this.props.filterOn &&
            <FlexGridFilter initialized={this.initializedFilter.bind(this)}/>}
        </MultiRow>
        <DeleteIconButton isDisabled={!!this.props.isReadOnly}/>
        <AddIconButton isDisabled={!!this.props.isReadOnly}/>
      </React.Fragment>
    );
  }

  /**
   * 矢印ボタン押下
   * @param {number} dest 1:上、-1:下
   */
  doMove = (dest) => {
    if (!this.grid) {
      return;
    }
    const selectedRows = this.grid.selectedRows;
    if (!selectedRows || selectedRows.length == 0) {
      return;
    }

    if (this.useStore) {
      if (dest > 0) {
        this.grid.collectionView.moveCurrentToPrevious();
      }
      if (dest < 0) {
        this.grid.collectionView.moveCurrentToNext();
      }
      // ストアのデータを変更
      this.props.doMoveItemMultiRowAction(
          selectedRows[0].dataItem, selectedRows[0].dataIndex, dest);
    } else {
      const collectionView = this.grid.collectionView;
      if (dest > 0) {
        this.grid.itemsSource.deferUpdate(function() {
          if (0 <= selectedRows[0].dataIndex - 1) {
            collectionView.sourceCollection.splice(
                selectedRows[0].dataIndex, 1); // 選択した行をcollectionViewから削除
            collectionView.sourceCollection.splice(
                selectedRows[0].dataIndex - 1, 0,
                selectedRows[0].dataItem); // 一個上に選択した行を挿入
            collectionView.refresh();
          }
        });
      }
      if (dest < 0) {
        this.grid.itemsSource.deferUpdate(function() {
          if (collectionView.itemCount > selectedRows[0].dataIndex + 1) {
            collectionView.sourceCollection.splice(
                selectedRows[0].dataIndex, 1); // 選択した行をcollectionViewから削除
            collectionView.sourceCollection.splice(
                selectedRows[0].dataIndex + 1, 0,
                selectedRows[0].dataItem); // 一個上に選択した行を挿入
            collectionView.refresh();
          }
        });
      }
    }
  };

  /**
   * データをストアに保存する処理
   * @param {object} s
   * @param {object} e
   */
  onGridDataChanged(s, e) {
    switch (e.action) {
      case DataChangeAction.Add:
        // 追加ボタン押下時のみデータ追加が発生するため、ここは通らない
        this.props.doAddItemMultiRowAction(e.newItem);
        break;
      case DataChangeAction.Remove:
        // 削除ボタン押下時のみデータ削除が発生するため、ここは通らない
        this.props.doRemoveItemMultiRowAction(e.itemIndex);
        break;
      case DataChangeAction.Change:
        this.props.doChangeItemMultiRowAction(e.newItem, e.itemIndex);
        break;
      default:
        throw new Error('Unknown data action');
    }
  }

  showEditIcon(s, e) {
    // 行ヘッダに編集アイコンを表示
    if (e.panel === s.rowHeaders &&
        e.col === (s.rowHeaders.columns.length - 1)) {
      e.cell.innerHTML = '<div class="centerPos"><span id="popupEdit" class="wj-glyph-pencil"></span></div>';
    }
  }

  showRadioButton(s, e) {
    // 行ヘッダにラジオボタンを表示
    if (e.panel === s.rowHeaders &&
      e.col === (s.rowHeaders.columns.length - 1)) {
      e.cell.innerHTML = '<div><input type="radio" name="envId" id="' + e.row + '"/></div>';
    }
  }

  setCheckBox(grid) {
    // 行ヘッダにチェックボックスを表示
    this.selector = new Selector(grid, {
      itemChecked: (s, e) => {
        let _selectedItems = grid.rows.filter((r) => r.isSelected);
        // MultiRowは2行同じデータが返ってくるので、重複を除く
        this.selectedItems = [];
        for (const _selectedItem of _selectedItems) {
          if (this.selectedItems) {
            if (this.selectedItems.filter(
                (data) =>
                  Object.hasOwnProperty.call(data.dataItem, 'Id') &&
                  Object.hasOwnProperty.call(_selectedItem.dataItem, 'Id') &&
                    data.dataItem.Id ==
                   _selectedItem.dataItem.Id).length > 0) {
              continue;
            }
            this.selectedItems.push(_selectedItem);
          }
        }
        // チェックボックスクリック時イベントがあれば実行
        const checkedFunction = this.props.checkedFunction;
        if (checkedFunction) {
          checkedFunction();
        }
      },
    });
    this.selector.column.grid.headersVisibility = wjgGrid.HeadersVisibility.All;
    this.selector.column =
      this.selector.column.grid.rowHeaders.columns.length == 2 ?
      this.selector.column.grid.rowHeaders.columns[1] :
      this.selector.column.grid.rowHeaders.columns[0];
    this.selectedItems = [];
  }

  initialized(grid) {
    const {initItems, getError} = this.props;
    // イベントの中でthis.stateやコンストラクタで定義した変数を使うためにselfを定義する
    const self = this;
    this.grid = grid;

    const rowHeaderType = this.props.rowHeaderType;
    const AddDeleteOn = this.props.AddDeleteOn;

    const showEditIcon = this.showEditIcon;
    const showRadioButton = this.showRadioButton;
    const editPopupItems = this.props.editPopupItems;
    const formatItemFunction = this.props.formatItemFunction;
    const checkedFunction = this.props.checkedFunction;
    const refreshedFunction = this.props.refreshedFunction;

    if (this.useStore) {
      // ストアでデータ管理する場合は初期処理でCollectionViewの各種設定を行う
      grid.itemsSource.trackChanges = true; // 変更追跡ON
      grid.itemsSource.newItemCreator = function() { // 新規行作成時の処理
        // 項目は新しく作成すること
        // 同じ変数を返すとGridが同じ行とみなし、同じデータが入ってしまう
        const items = {};
        for (const key in initItems) {
          if (Object.hasOwnProperty.call(initItems, key)) {
            items[key] = initItems[key];
          }
        }
        return items;
      };
      grid.itemsSource.getError = getError; // 編集時の検証エラー設定
      self.selectedItems = []; // 保持している選択行をクリア
    }

    // editの場合、行ヘッダーを2行にする
    if (rowHeaderType == 'edit') {
      grid.rowHeaders.columns.push(new wjgGrid.Column());
      grid.mergeManager = new CustomMergeManager(grid);
    }
    if (grid.rowHeaders.columns.length == 2) {
      grid.rowHeaders.columns[0].width = 15;
    }


    // 行ヘッダー設定(チェックボックス)
    if (rowHeaderType === 'check') {
      this.setCheckBox(grid);
    }

    // 行追加、削除ボタン設定
    if (AddDeleteOn) {
      // add a footer row
      const footerRow = new wjgGrid.GroupRow();
      footerRow.height = 50;
      grid.columnFooters.rows.push(footerRow);
    }

    // セルの書式設定を行う
    grid.formatItem.addHandler(function(s, e) {
      const col = s.columns[e.col];
      // ヘッダーのみ折り返す
      wjCore.toggleClass(e.cell, 'wj-wrap', s.columnHeaders === e.panel);

      if (s.columnHeaders === e.panel) {
        // 列ヘッダーに\nがあれば<br/>に置換する
        if (e.cell.innerHTML &&
          e.cell.innerHTML.indexOf('\\n') != -1) {
          e.cell.innerHTML = e.cell.innerHTML.replace(/\\n/g, '<br/>');
        }
        // ヘッダーのボーダーの色を黒にする
        if (['edit', 'SerialNumber__c', 'AttachOrderNo__c',
          'FormalOrderNo'].includes(col.binding)) {
          e.cell.style.borderBottom = 'solid 1px #000';
        }
      }

      if (AddDeleteOn) {
        // add edit button
        if (e.panel === s.cells) {
          const item = s.rows[e.row].dataItem;
          if (col.binding === 'edit') {
            e.cell.innerHTML = document.getElementById('btnMode').innerHTML; // DeleteIconButtonのid
            e.cell['dataItem'] = item;
          }
        }
        // add footer button
        if (e.panel === s.columnFooters && col.binding === 'edit' &&
            document.getElementById('btnTblFooter')) {
          e.cell.innerHTML = document.getElementById('btnTblFooter').innerHTML; // AddIconButtonのid
        }
      }

      // 行ヘッダー設定
      if (rowHeaderType === 'edit') {
        showEditIcon(s, e);
      }
      if (rowHeaderType === 'radio') {
        showRadioButton(s, e);
      }

      // セルの書式設定
      if (formatItemFunction) {
        formatItemFunction(s, e, grid);
      }
    });

    grid.resizingColumn.addHandler(function(s, e) {
      // ヘッダーのみ、列幅変更時に高さを変更し、列名を見えるようにする
      for (let i = 0; i < grid.columnHeaders.rows.length; i++) {
        if (grid.columnHeaders.getCellElement(i, e.col)) {
          const height =
            grid.columnHeaders.getCellElement(i, e.col).scrollHeight;
          if (height > grid.columnHeaders.rows.defaultSize) {
            grid.autoSizeRow(i, true);
          }
        }
      }
    });

    // コントロールが内容を更新した後で発生する処理
    grid.refreshed.addHandler(function(s, e) {
      if (refreshedFunction) {
        refreshedFunction(s, e);
      }
    });

    // グリッド行がデータソースの項目に連結された後に発生する処理
    grid.loadedRows.addHandler(function(s, e) {
      if (s.rows && s.rows.length > 0 && self.isRestore) {
        self.restoreSelectedItems(rowHeaderType);
        // self.restoreScrollPosition(); TODO 期待通りにうごかないのであとで修正する
        if (rowHeaderType === 'check') {
          // チェックボックスの選択状態を復元
          self.onItemChecked();
        }
        if (rowHeaderType === 'radio') {
          // ラジオボタンの選択状態を復元
          const hasId = (s.rows.filter((r) => r.dataItem &&
           Object.hasOwnProperty.call(
               r.dataItem, RADIO_UNIQUE_KEY)).length > 0);
          if (hasId) {
            self.selectedItems =
              s.rows.filter((r) => r.dataItem &&
                Object.hasOwnProperty.call(r.dataItem, RADIO_UNIQUE_KEY) &&
                (r.dataItem[RADIO_UNIQUE_KEY] == self.radioCheckId));
          } else {
            self.selectedItems =
              s.rows.filter((r) => r.index == self.radioCheckId);
          }
          if (checkedFunction) {
            checkedFunction();
          }
        }
      }
    });

    grid.beginningEdit.addHandler(function(s, e) {
      const element = e.panel.getCellElement(e.row, e.col);
      if (element && element.className) {
        if (element.className.indexOf('wj-state-disabled') != -1) {
          // 'wj-state-disabled'が設定してあるセルは編集不可
          e.cancel = true;
        }
      }
    });

    grid.hostElement.addEventListener('click', async (e) => {
      let key = '';
      if (e.target.nodeName == 'path') {
        // material UI のSVG IconはnodeNameがpathになる
        key = e.target.parentNode.id;
      } else {
        key = e.target.id;
      }
      const cv = grid.collectionView;
      switch (key) {
        case 'btnDeleteRow':
          const ht = grid.hitTest(e);
          if (ht) {
            let index = 0;
            if (ht.row > 1) {
              index = ht.row % 2 == 0 ? ht.row / 2 : (ht.row - 1) / 2;
            }
            if (this.useStore) {
              const delItem = this.props.items[index];
              if (delItem && Object.keys(delItem).length > 0) {
                await this.props.doRemoveItemMultiRowAction(index);
                if (cv.trackChanges) {
                  cv.itemsRemoved.push(delItem);
                }
                cv.refresh();
              }
            } else {
              cv.beginUpdate();
              cv.removeAt(index);
              cv.endUpdate();
            }
          }
          break;
        case 'btnAddRow':
          let _itemsCount = cv.sourceCollection.length;
          if (this.useStore) {
            _itemsCount = this.props.items.length;
          }
          if (_itemsCount < 100) {
            if (this.useStore) {
              const newItem = cv.newItemCreator ? (cv.newItemCreator)() : {};
              newItem['SerialNumber__c'] = 1;
              if (_itemsCount > 0) {
              // ユーザー入力補助のため、最終行の電柱2を追加行の電柱1にコピーする
                const lastRow = this.props.items[_itemsCount - 1];
                // 最大通し番号を取得
                let maxSerialNumber = 0;
                for (const item of this.props.items) {
                  if (maxSerialNumber < item.SerialNumber__c) {
                    maxSerialNumber = item.SerialNumber__c;
                  }
                }
                for (const _key in newItem) {
                  if (Object.hasOwnProperty.call(lastRow, _key)) {
                    if (['SzbtItiId1__c', 'StbKobetuId1__c', 'SenroCode1__c', 'SenroName1__c',
                      'SenroNameKana1__c', 'DntNo1__c', 'DntCategory1__c', 'KyogaCategory1__c',
                      'DntNo1ManualInput__c', 'K6KansnNo1__c', 'K6BunkOne1__c', 'K6BunkTwo1__c',
                      'K6BunkThree1__c', 'K22SzbtNo1__c', 'K22GatiCategory1__c', 'K6K22HeigaCategory1__c',
                      'Dsp_DntNo1__c', 'Dsp_SenroName1__c',
                    ].includes(_key)) {
                      newItem[_key] = lastRow[_key.replace('1', '2')];
                    } else if (['SzbtItiId2__c', 'StbKobetuId2__c', 'SenroCode2__c', 'SenroName2__c',
                      'SenroNameKana2__c', 'DntNo2__c', 'DntCategory2__c', 'KyogaCategory2__c',
                      'DntNo2ManualInput__c', 'K6KansnNo2__c', 'K6BunkOne2__c', 'K6BunkTwo2__c',
                      'K6BunkThree2__c', 'K22SzbtNo2__c', 'K22GatiCategory2__c', 'K6K22HeigaCategory2__c',
                      'ContractDnt2__c', 'ContractDnt1__c', 'Dsp_SenroName2__c',
                      'Id', 'TrsyaUserId__c', 'UpsyaUserId__c'].includes(_key)) {
                      newItem[_key] = null;
                    } else if (_key == 'SerialNumber__c') {
                      newItem[_key] = ++maxSerialNumber;
                    } else if (_key == 'Dsp_DntNo2__c') {
                      newItem[_key] = '未設定'; // SFの設定に合わせる
                    } else {
                      newItem[_key] = lastRow[_key];
                    }
                  }
                }
              }
              await this.props.doAddItemMultiRowAction(newItem);
              if (cv.trackChanges) {
                cv.itemsAdded.push(newItem);
              }
              cv.refresh();
            } else {
              const _sourceCollection = cv.sourceCollection;
              cv.beginUpdate();
              const newItem = cv.addNew();
              if (newItem) {
                newItem['SerialNumber__c'] = 1;
                if (_itemsCount > 0) {
                  // ユーザー入力補助のため、最終行の電柱2を追加行の電柱1にコピーする
                  const lastRow = _sourceCollection[_itemsCount - 1];
                  // 最大通し番号を取得
                  let maxSerialNumber = 0;
                  for (const item of _sourceCollection) {
                    if (maxSerialNumber < item.SerialNumber__c) {
                      maxSerialNumber = item.SerialNumber__c;
                    }
                  }
                  for (const _key in newItem) {
                    if (Object.hasOwnProperty.call(lastRow, _key)) {
                      if (['SzbtItiId1__c', 'StbKobetuId1__c', 'SenroCode1__c', 'SenroName1__c',
                        'SenroNameKana1__c', 'DntNo1__c', 'DntCategory1__c', 'KyogaCategory1__c',
                        'DntNo1ManualInput__c', 'K6KansnNo1__c', 'K6BunkOne1__c', 'K6BunkTwo1__c',
                        'K6BunkThree1__c', 'K22SzbtNo1__c', 'K22GatiCategory1__c', 'K6K22HeigaCategory1__c',
                        'Dsp_DntNo1__c', 'Dsp_SenroName1__c',
                      ].includes(_key)) {
                        newItem[_key] = lastRow[_key.replace('1', '2')];
                      } else if (['SzbtItiId2__c', 'StbKobetuId2__c', 'SenroCode2__c', 'SenroName2__c',
                        'SenroNameKana2__c', 'DntNo2__c', 'DntCategory2__c', 'KyogaCategory2__c',
                        'DntNo2ManualInput__c', 'K6KansnNo2__c', 'K6BunkOne2__c', 'K6BunkTwo2__c',
                        'K6BunkThree2__c', 'K22SzbtNo2__c', 'K22GatiCategory2__c', 'K6K22HeigaCategory2__c',
                        'ContractDnt2__c', 'ContractDnt1__c', 'Dsp_SenroName2__c',
                        'Id', 'TrsyaUserId__c', 'UpsyaUserId__c'].includes(_key)) {
                        newItem[_key] = null;
                      } else if (_key == 'SerialNumber__c') {
                        newItem[_key] = ++maxSerialNumber;
                      } else if (_key == 'Dsp_DntNo2__c') {
                        newItem[_key] = '未設定'; // SFの設定に合わせる
                      } else {
                        newItem[_key] = lastRow[_key];
                      }
                    }
                  }
                }
                cv.commitNew();
                cv.endUpdate();
              }
            }
          } else {
            if (this.props.doShowMessage) {
              this.props.doShowMessage({
                message: {
                  id: 'CE0055',
                  values: ['100'],
                },
              });
            }
          }
          break;
        case 'popupEdit':
          if (rowHeaderType === 'edit' && editPopupItems) {
            editPopupItems(grid, e);
          }
          break;
        default:
          break;
      }
    });

    grid.hostElement.addEventListener('change', (e) => {
      if (e.target instanceof HTMLInputElement && e.target.type === 'radio' && e.target.name === 'envId') {
        const hasId = (grid.rows.filter((r) => r.dataItem &&
          Object.hasOwnProperty.call(r.dataItem, RADIO_UNIQUE_KEY)).length > 0);
        self.radioCheckId = e.target.id;
        if (hasId) {
          self.selectedItems =
            grid.rows.filter((r) => r.dataItem &&
              Object.hasOwnProperty.call(r.dataItem, RADIO_UNIQUE_KEY) &&
              (r.dataItem[RADIO_UNIQUE_KEY] == self.radioCheckId));
        } else {
          self.selectedItems =
            grid.rows.filter((r) => r.index === self.radioCheckId);
        }

        // クリック時イベントがあれば設定
        if (checkedFunction) {
          checkedFunction();
        }
      }
    });

    // セル編集完了時の処理
    grid.cellEditEnding.addHandler(function(s, e) {
      // 入力値はactiveEditorから取得
      const editor = s.activeEditor;
      const inputValue = editor ? editor.value : '';
      self.cellEditEndFunc(s, e, inputValue);
    });

    // ペースト時の処理
    grid.pastingCell.addHandler(function(s, e) {
      // 入力値はイベントから取得
      const inputValue = e.data;
      self.cellEditEndFunc(s, e, inputValue);
    });
  }


  /**
   * セル編集終了時共通処理。
   *
   * @param {FlexGrid} s FlexGrid
   * @param {CellRangeEventArgs} e CellRangeEventArgs
   * @param {string} inputValue 入力値。cellEditEndingから呼ぶ際はs.activeEditor.value、pastingCellから呼ぶ際はe.dataを指定
   */
  cellEditEndFunc(s, e, inputValue) {
    let displayValue = inputValue;

    // カスタムDataMap使用判定
    const dataMap = this._checkCustomDataMapColumn(s, e);
    if (dataMap != null) {
      // 表示値を取得
      const dataItem = s.rows[e.row].dataItem;
      displayValue =
        this._getDataMapDisplayValue(dataMap, dataItem, inputValue);
      if (displayValue == null) {
        // 入力可能な文字列でない場合は入力イベントキャンセル
        e.cancel = true;
        return;
      }
    }

    // セル編集完了時の処理が指定されていれば実行
    if (this.onCellEditEnding) {
      this.onCellEditEnding(s, e, displayValue);
    }
  }

  /**
   * カスタムDataMap使用判定。
   *
   * @param {FlexGrid} s FlexGrid
   * @param {CellRangeEventArgs} e CellRangeEventArgs
   * @return {DataMap|null} カスタムDataMap使用時はDataMap。未使用時はnull
   */
  _checkCustomDataMapColumn(s, e) {
    // 対象のカラムを取得
    const column = s.columns[e.col];

    // DataMapが未設定の場合はカスタムDataMap未使用
    const dataMap = column.dataMap;
    if (!dataMap) {
      return null;
    }

    // customDataMapBindsの指定がない場合はカスタムDataMap未使用
    if (!this.customDataMapBinds) {
      return null;
    }

    // customDataMapBindsのバインド項目ではない場合はカスタムDataMap未使用
    if (!this.customDataMapBinds.includes(column.binding)) {
      return null;
    }

    return dataMap;
  }

  /**
   * 表示値の取得
   *
   * DataMapで入力を許可された文字列の場合、その文字列を返却する。
   * 許可されない文字列の場合、nullを返却する。
   * コード値が入力されていた場合は、表示値に変換して返却する。
   *
   * @param {DataMap} dataMap DataMap
   * @param {object} dataItem 行の情報
   * @param {string} value 入力値
   * @return {string|null} 表示値
   */
  _getDataMapDisplayValue(dataMap, dataItem, value) {
    const displayValues = dataMap.getDisplayValues(dataItem);

    // 入力値が表示値の場合、displayValuesに含まれればペースト可
    if (displayValues.includes(value)) {
      return value;
    } else {
      // 入力値がコード値の場合、DisplayValuesからコードを取得して比較
      // (単純にgetDisplayValue(key)を使用すると、入力不可の項目も取得されるため)
      for (const displayValue of displayValues) {
        const codeValue = dataMap.getKeyValue(displayValue);

        // 入力値と一致するコード値の場合、その表示値を返却
        if (value == codeValue) {
          return displayValue;
        }
      }
    }

    return null;
  }

  initializedFilter(filter) {
    this.filter = filter;
    const self = this;
    this.filter.filterColumns = this.props.filters;
    this.filter.showSortButtons = false;

    this.filter.filterChanging.addHandler((s, e) => {
      if (self.filterChanging) {
        self.filterChanging(s, e);
      }
    });
  }

  // チェックボックスまたはラジオボタンで選択した行データを返す
  selectedItem() {
    return this.selectedItems != null ? this.selectedItems : [];
  }

  /**
   * 選択行の件数を返す
   * @return {number}
   */
  selectedItemCount() {
    return this.selectedItems != null ? this.selectedItems.length : 0;
  }

  /**
   * チェックボックスチェンジイベント発行
   */
  onItemChecked() {
    if (this.selector) {
      this.selector.onItemChecked();
    }
  }

  /**
   * バインドしたデータのisSelectedを設定
   * @param {bool} selected true:選択、false:未選択
   */
  setAllSelected(selected) {
    if (this.grid != null && this.grid.rows.length > 0) {
      for (const row of this.grid.rows) {
        row.isSelected = selected;
      }
    }
  }

  /**
   * ラジオボタン、チェックボックスの選択状態復元
   * @param {string} rowHeaderType ヘッダーに表示する選択項目名
   */
  restoreSelectedItems(rowHeaderType) {
    if (this.state.screenId) {
      if (this.grid == null || this.grid.rows == null ||
        this.grid.rows.length == 0) {
        return;
      }
      const selection = this.props.selections.filter(
          (data) => data.screenId == this.state.screenId);
      if (selection.length == 0 ||
          selection[0].compareKey == null ||
          selection[0].compareKey == '' ||
          selection[0].selectedItems == null ||
          selection[0].selectedItems.length == 0) {
        return;
      }
      // キーが一致するデータを選択する
      const compareKey = selection[0].compareKey;
      const selectedItems = selection[0].selectedItems ?
        selection[0].selectedItems : [];
      if (!Object.hasOwnProperty.call(selectedItems[0], compareKey) ||
        !Object.hasOwnProperty.call(this.grid.rows[0].dataItem, compareKey)) {
        return;
      }
      for (const selectedItem of selectedItems) {
        const sameRows = this.grid.rows.filter(
            (row) => row.dataItem[compareKey] == selectedItem[compareKey]);
        if (rowHeaderType === 'check') {
          // multirowは同じものが複数行あるので、全てチェックする
          // そうしないと行の一部が未選択になってしまう
          for (const sameRow of sameRows) {
            sameRow.isSelected = true;
          }
        }
        if (sameRows.length > 0 && rowHeaderType === 'radio') {
          // ラジオボタンはないので複数選択未対応
          this.radioCheckId = sameRows[0].dataItem[compareKey];
        }
      }
    }
  }

  /**
   * スクロール位置復元
   */
  restoreScrollPosition() {
    if (this.state.screenId) {
      if (this.grid == null || this.grid.rows == null ||
          this.grid.rows.length == 0) {
        return;
      }
      const dataList = this.props.scrollPosition.filter(
          (data) => data.screenId == this.state.screenId);
      if (dataList.length == 0 ||
        dataList[0].scrollPosition == null) {
        return;
      }
      // TODO y軸が復元できない。値を設定しても0になる
      this.grid.scrollPosition = new wijmo.Point(
          dataList[0].scrollPosition.x, dataList[0].scrollPosition.y);
      this.grid.refresh(false);
    }
  }

  /**
   * グリッドを返す
   * @return {object} グリッド本体
   */
  getGrid() {
    return this.grid;
  }

  /**
   * データを返す
   * @return {object} ストアに保存したデータ
   */
  getItems() {
    return this.props.items;
  }

  /**
   * CollectionViewのデータを返す
   * @return {object} CollectionViewのデータ
   */
  getSourceCollection() {
    if (!this.grid || !this.grid.collectionView) {
      return null;
    }
    return this.grid.collectionView.sourceCollection;
  }

  /**
   * 追加、変更、削除したデータを返す
   * 注意)CollectionView メソッド（editItem /commitEdit、 addNew /commitNew、remove）を使用しないと
   *     同じ行を追加、削除したとき、 itemsAddedとitemsRemovedにそれぞれデータが入る。
   *     同じ行を複数回変更したとき、変更した回数分itemsEditedにデータが入る。
   * @return {object} 追加、変更、削除したデータ
   * {
   *   itemsAdded: ObservableArray[{追加行データ}, {...}, ...],
   *   itemsEdited: ObservableArray[{変更行データ}, {...}, ...],
   *   itemsRemoved: ObservableArray[{削除行データ}, {...}, ...],
   * }
   */
  itemsAllChanged() {
    return {
      itemsAdded: this.grid.collectionView.itemsAdded,
      itemsEdited: this.grid.collectionView.itemsEdited,
      itemsRemoved: this.grid.collectionView.itemsRemoved,
    };
  }

  /**
   * 編集した内容をコミットする
   */
  commit() {
    if (this.grid != null && this.grid.collectionView != null) {
      const cv = this.grid.collectionView;
      if (cv.trackChanges) {
        cv.commitEdit();
      }
    }
  }

  /**
   * データを追加、変更、削除したかチェックする
   * @return {bool} true:変更あり, false:変更なし
   */
  isItemsModified() {
    let _isModified = false;
    if (this.grid && this.grid.collectionView) {
      _isModified = this.grid.collectionView.itemsAdded.length > 0 ||
                  this.grid.collectionView.itemsEdited.length > 0 ||
                  this.grid.collectionView.itemsRemoved.length > 0;
    }
    return _isModified;
  }

  /**
   * 編集した内容をコミットし、データが変更されているかチェックする
   * グリッドが読み取り専用の場合はfalseを返す
   * @return {bool} true:変更あり, false:変更なし
   */
  commitItemsModified() {
    let _isModified = false;
    if (this.props.isReadOnly === false) {
      this.commit();
      _isModified = this.isItemsModified();
    }
    return _isModified;
  }

  /**
   * グリッドのデータをDBに登録した後呼び出す。
   * clearChangesを実行すると
   * itemsAdded 、itemsRemoved 、itemsEdited
   * の全ての変更をクリアする。
   */
  clearChanges() {
    if (this.grid && this.grid.collectionView) {
      this.grid.collectionView.clearChanges();
    }
  }

  /**
   * ストアに初期値を設定する
   * @param {string} key 画面Id
   *                     画面Idが重複する場合は1027_sen,1027_tenのようにユニークな文字列を渡す
   * @param {object} items オブジェクト
   * @param {bool} restore true:画面の状態を復元する、false:復元しない
   */
  setInitItems(key, items, restore=true) {
    this.selectedItems = [];
    this.radioCheckId = null;
    this.setScreenState(key, restore);
    this.props.doSetListMultiRowAction(items);
    this.clearChanges();
  }

  /**
   * ストアにデータを設定する
   * @param {object} items オブジェクト
   * @param {bool} restore true:画面の状態を復元する、false:復元しない
   */
  setItems(items, restore=true) {
    this.isRestore = restore;
    this.props.doSetListMultiRowAction(items);
  }

  /**
   * 画面の情報を設定する
   * @param {string} _screenId 画面Id
   * @param {bool} restore true:画面の状態を復元する、false:復元しない
   */
  setScreenState(_screenId, restore=true) {
    this.isRestore = restore;
    this.setState({screenId: _screenId});
  }

  /**
   * 変更したデータをストアに保存する
   * @param {object} item 変更データ
   * @param {number} itemIndex 行番号
   */
  storeEditItem(item, itemIndex) {
    if (!item) {
      return;
    }
    if (itemIndex == undefined ||
      itemIndex == null ||
      itemIndex < 0) {
      return;
    }
    this.props.doChangeItemMultiRowAction(item, itemIndex);
    if (this.grid?.collectionView?.trackChanges) {
      if (item) {
        this.grid.collectionView.itemsEdited.push(item);
      }
    }
  }

  /**
   * 以下の状態を保存する
   * ・ラジオボタンまたはチェックボックスで選択したデータ
   * ・スクロール位置
   * @param {string} screenId 画面Id
   * @param {array} compareKey
   *                  一覧のデータと保存した選択データを比較して同じ行か判別するためのキー
   *                  selectedItemsに存在するキーを1つ以上設定する
   * @param {bool} isClear true: ストアに保存した状態をクリアする
   */
  saveScreenState(screenId, compareKey, isClear=false) {
    this.saveSelectedItems(screenId, compareKey, isClear);
    this.saveScrollPosition(screenId, isClear);
  }

  /**
     * ラジオボタンまたはチェックボックスで選択したデータを保存する
     * @param {string} screenId 画面Id
     * @param {array} compareKey
     *                  一覧のデータと保存した選択データを比較して同じ行か判別するためのキー
     *                  selectedItemsに存在するキーを1つ以上設定する
     * @param {bool} isClear true: ストアに保存した選択行をクリアする
     */
  saveSelectedItems(screenId, compareKey, isClear=false) {
    if (!isClear) {
      let _dataItems = [];
      for (const selectedItem of this.selectedItems) {
        _dataItems.push(selectedItem.dataItem);
      }
      this.props.doSaveSelectedItems(
          screenId, compareKey, _dataItems);
    } else {
      this.selectedItems = [];
      this.radioCheckId = null;
      this.props.doSaveSelectedItems(
          screenId, compareKey, null);
    }
  }

  /**
     * スクロール位置を保存する
     * @param {string} screenId 画面Id
     * @param {bool} isClear true: ストアに保存した状態をクリアする
     */
  saveScrollPosition(screenId, isClear=false) {
    if (this.grid == null) {
      return;
    }
    if (!isClear) {
      const _scrollPosition = this.grid.scrollPosition;
      this.props.doSaveScrollPosition(
          screenId, _scrollPosition);
    } else {
      this.props.doSaveScrollPosition(
          screenId, null);
    }
  }

  /**
   * セルの選択範囲を設定
   * @param {number} row
   * @param {number} col
   */
  setCellRange(row, col) {
    if (this.grid) {
      this.grid.selection = new wjgGrid.CellRange(row, col);
    }
  }
}

/**
 * CollectionView生成
 * @param {array} items
 * @param {bool} trackChanges
 * @param {object} initItems
 * @param {func} getError
 * @return {object} CollectionView
 */
export function createCollectionView(items, trackChanges, initItems, getError) {
  const _list = [];
  for (const item of items) {
    let data = {};
    Object.assign(data, item);
    _list.push(data);
  }
  const cv = new CollectionView(
      _list,
      {
        trackChanges: trackChanges, // 変更管理ON
        newItemCreator: function() {
          // 項目は新しく作成すること
          // 同じ変数を返すとGridが同じ行とみなし、同じデータが入ってしまう
          const items = {};
          for (const key in initItems) {
            if (Object.hasOwnProperty.call(initItems, key)) {
              items[key] = initItems[key];
            }
          }
          return items;
        },
        getError: getError,
      },
  );
  return cv;
}

CustomMultiRow.propTypes = {
  AddDeleteOn: PropTypes.bool,
  allowSorting: PropTypes.string,
  checkedFunction: PropTypes.func,
  children: PropTypes.array,
  counterOn: PropTypes.bool,
  ArrowButtonOn: PropTypes.bool,
  data: PropTypes.array,
  editPopupItems: PropTypes.func,
  exceptFilters: PropTypes.array,
  filterOn: PropTypes.bool,
  formatItemFunction: PropTypes.func,
  frozenRows: PropTypes.number,
  frozenColumns: PropTypes.number,
  headersVisibility: PropTypes.string,
  refreshedFunction: PropTypes.func,
  rowHeaderType: PropTypes.string,
  style: PropTypes.object,
  isReadOnly: PropTypes.bool,
  initItems: PropTypes.object,
  items: PropTypes.array,
  filters: PropTypes.array,
  headerLayoutDefinition: PropTypes.object,
  validateEdits: PropTypes.bool,
  useStore: PropTypes.bool,
  selections: PropTypes.array,
  scrollPosition: PropTypes.array,
  doShowMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  getError: PropTypes.func,
  doSetListMultiRowAction: PropTypes.func,
  doAddItemMultiRowAction: PropTypes.func,
  doRemoveItemMultiRowAction: PropTypes.func,
  doChangeItemMultiRowAction: PropTypes.func,
  doMoveItemMultiRowAction: PropTypes.func,
  filterChanging: PropTypes.func,
  customDataMapBinds: PropTypes.array,
  onCellEditEnding: PropTypes.func,
  doSaveSelectedItems: PropTypes.func,
  doSaveScrollPosition: PropTypes.func,
};

const mapStateToProps = (state) => {
  const _items = state.grid.multiRowEditItems?.multiRowItems ?
                    state.grid.multiRowEditItems.multiRowItems : [];
  return {
    items: _items,
    selections: state.grid.selections != null ? state.grid.selections : [],
    scrollPosition:
      state.grid.scrollPosition != null ? state.grid.scrollPosition : [],
  };
};

const mapDispatchToProps = {
  doSetListMultiRowAction: gridOperations.doSetListMultiRowAction,
  doAddItemMultiRowAction: gridOperations.doAddItemMultiRowAction,
  doRemoveItemMultiRowAction: gridOperations.doRemoveItemMultiRowAction,
  doChangeItemMultiRowAction: gridOperations.doChangeItemMultiRowAction,
  doMoveItemMultiRowAction: gridOperations.doMoveItemMultiRowAction,
  doSaveSelectedItems: gridOperations.doSaveSelectedItems,
  doSaveScrollPosition: gridOperations.doSaveScrollPosition,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        null,
        {forwardRef: true},
    )(CustomMultiRow),
);

class CustomMergeManager extends wjgGrid.MergeManager {
  _baseMergeManager;

  constructor(grid) {
    super();
    // save instance of old merge manager to provide default behaviour whenever required
    this._baseMergeManager = grid.mergeManager;
  }

  getMergedRange(panel, r, c, clip = true) {
    if (
      panel.cellType == wjgGrid.CellType.RowHeader ||
      panel.cellType == wjgGrid.CellType.TopLeft
    ) {
      // create basic cell range
      let rng = new wjgGrid.CellRange(r, c);
      // get old merged range
      let rg = this._baseMergeManager.getMergedRange(panel, r, c, clip);
      // update new range to restrict the columns merging
      rng.row = rg.row;
      rng.row2 = rg.row2;
      rng.col = c;
      rng.col2 = c;

      return rng;
    }
    // return default merge range for other cellType
    return this._baseMergeManager.getMergedRange(panel, r, c, clip);
  }
}
